import React from 'react';
import TeamsContainer from '../TeamsContainer';
import { DashboardsCellWrapper } from '../../shared/components';

export const HomepagesCell = ({
  data,
  homepagesById,
  createHomepageClicked,
  setPreviewPanel,
  setDialog
}) => {
  const handleAddClick = () => {
    createHomepageClicked('Teams View add page card');
  };

  return (
    <DashboardsCellWrapper
      Container={TeamsContainer}
      items={data.homepages}
      itemsById={homepagesById}
      teamId={data.teamId}
      setDialog={setDialog}
      setPreviewPanel={setPreviewPanel}
      showAddButton={true}
      addButtonConfig={{
        onClick: handleAddClick,
        dataTestId: 'add-homepage-button'
      }}
    />
  );
};
